import React from 'react'
import { useParams } from 'react-router';
import Sidebar from 'components/menu/sidebar'
import SidebarSmall from 'components/menu/sidebar-small'
import Navbar from 'components/menu/navbar'
import { useCheckPermissions } from 'hooks/use-check-permissions';

export const BaseLayout = ({ component: Component, ...rest }) => {
  const componentParams = useParams();

  var result = useCheckPermissions();
  if (result != null)
    return result;
  
  return (
    <div>
      <SidebarSmall {...rest} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <Sidebar {...rest} />
            <main className="content">
              <Navbar />
              <Component {...rest} params={componentParams} />
            </main>
          </div>
        </div>
      </div>
    </div>
  )
};
